var map = {
	"./some-logo__facebook.svg": "ZxA6",
	"./some-logo__github.svg": "dUP9",
	"./some-logo__x.svg": "LAWk",
	"./some-logo__youtube.svg": "dMQK"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pcP9";